// ProctorOverlay.jsx

import { Box, Typography, Button } from "@mui/material";

const ProctorOverlay = ({ open, title }) => {
    if (!open) return null;

    return (
        <Box
            position="fixed"
            top={0}
            left={0}
            right={0}
            bottom={0}
            display="flex"
            justifyContent="center"
            alignItems="center"
            bgcolor="rgba(0,0,0,0.6)"
            zIndex={9999}
            sx={{
                backdropFilter: "blur(6px)",
                color: "white",
                flexDirection: "column",
                textAlign: "center",
            }}
        >
            <Typography variant="h6" fontWeight={700}>
                {title}
            </Typography>

            <Typography mt={1} mb={2}>
                Aktifkan kembali untuk melanjutkan ujian.
            </Typography>

            <Button
                variant="contained"
                color="warning"
                onClick={() => window.location.reload()}
            >
                Coba Lagi
            </Button>
        </Box>
    );
};

export default ProctorOverlay;